import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../env";
import { useAuth } from "../AuthContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";

import { Card } from "primereact/card";
import DerogationView from "./viev-derogation";

const Derogation = () => {
  const { setCode, language, bundle } = useAuth();
  const paginatorLeft = (
    <Button type="button" icon="pi pi-refresh" className="p-button-text" />
  );
  const paginatorRight = (
    <Button type="button" icon="pi pi-cloud" className="p-button-text" />
  );
  const items = [
    {
      label:
        language === "ar" ? "طلبات تنازل" : "Mes demandes de cession du bien",
    },
  ];
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [data, setData] = useState([]);
  const [expandedRows, setExpandedRows] = useState(null);
  const home = { icon: "pi pi-home", url: "/" };
  const [viewVisible, setViewVisible] = useState(false);
  const [selectedDerogation, setSelectedDerogation] = useState(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: null,
    sortOrder: null,
  });

  const navigate = useNavigate();

  const loadLazyData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`api/derogations?all=true`, {
        params: {
          page: lazyParams.page + 1,
          per_page: lazyParams.rows,
        },
      });
      const status = response.status;
      if (status >= 200 && status < 300) {
        setData(response.data);
        setTotalRecords(response.data.meta.total);
      }
    } catch (error) {
      const status = error.response.status;
      setCode(status);
      navigate("/Error");
    }
    setLoading(false);
  };

  useEffect(() => {
    loadLazyData();
  }, [lazyParams]); // eslint-disable-line react-hooks/exhaustive-deps

  const onViewClick = (rowData) => {
    setSelectedDerogation(rowData);
    setViewVisible(true);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <Button
          label={language === "ar" ? "عرض" : "View"}
          icon="pi pi-eye"
          className="p-button-sm p-button-info"
          onClick={() => onViewClick(rowData)}
        />
      </div>
    );
  };

  const rowExpansionTemplate = (data) => {
    return (
      <>
        <Card
          style={{ textAlign: language === "ar" ? "right" : "left" }}
          title={language === "ar" ? "الانشغال" : "Détail de doléance"}
        >
          {data.description}
        </Card>
        <Card
          style={{
            textAlign: language === "ar" ? "right" : "left",
            marginTop: "4px",
          }}
          title={language === "ar" ? "إجابة " : "Réponse"}
          subTitle={data.date_response}
        >
          {data.reponse}
        </Card>
      </>
    );
  };

  const onPage = (event) => {
    setLazyParams(event);
  };

  return (
    <>
      {
        <>
          <div className="card border-light mb-3">
            <div className="card-body">
              <BreadCrumb model={items} home={home} />
            </div>
          </div>
          <DataTable
            lazy
            loading={loading}
            first={lazyParams.first}
            totalRecords={totalRecords}
            dataKey="id"
            rows={lazyParams.rows}
            rowsPerPageOptions={[5, 10, 20, 50]}
            responsiveLayout="stack"
            stripedRows
            paginator
            value={data.data}
            emptyMessage={
              language === "ar" ? (
                <div style={{ textAlign: "right" }}>{bundle.no_data}</div>
              ) : (
                <div>{bundle.no_data}</div>
              )
            }
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate={bundle.affiche_a_de_label}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            onPage={onPage}
            onRowToggle={(e) => setExpandedRows(e.data)}
            expandedRows={expandedRows}
            rowExpansionTemplate={rowExpansionTemplate}
          >
            <Column
              body={actionBodyTemplate}
              header="Actions"
              style={{ width: "10em", textAlign: "center" }}
            />
            <Column
              field="nom"
              header={language === "ar" ? "الاسم" : "Nom"}
              bodyStyle={{ textAlign: language === "ar" ? "right" : "left" }}
            ></Column>

            <Column
              field="prenom"
              header={language === "ar" ? "اللقب" : "Prénom"}
              bodyStyle={{ textAlign: language === "ar" ? "right" : "left" }}
            ></Column>

            <Column
              field="nin"
              header={language === "ar" ? "الرقم الوطني" : "NIN"}
              bodyStyle={{ textAlign: language === "ar" ? "right" : "left" }}
            ></Column>

            <Column
              field="email"
              header={language === "ar" ? "البريد الإلكتروني" : "Email"}
              bodyStyle={{ textAlign: language === "ar" ? "right" : "left" }}
            ></Column>

            <Column
              field="telephone"
              header={language === "ar" ? "الهاتف" : "Téléphone"}
              bodyStyle={{ textAlign: language === "ar" ? "right" : "left" }}
            ></Column>

            <Column
              field="statut"
              header={language === "ar" ? "الحالة" : "Statut"}
              bodyStyle={{ textAlign: language === "ar" ? "right" : "left" }}
              body={(rowData) => {
                let color = "gray";

                switch (rowData.statut) {
                  case "Rejete":
                    color = "red";
                    break;
                  case "Acceptee":
                    color = "green";
                    break;
                  case "A l'Opgi":
                    color = "blue";
                    break;
                  case "En cours":
                    color = "gray";
                    break;
                  default:
                    color = "black";
                }

                return (
                  <span style={{ color, fontWeight: "bold" }}>
                    {rowData.statut}
                  </span>
                );
              }}
            />
          </DataTable>
          {/* Modal for viewing derogation details */}
          <DerogationView
            visible={viewVisible}
            onHide={() => {
              setViewVisible(false);
              loadLazyData();
            }}
            derogation={selectedDerogation}
            language={language}
          />
        </>
      }
    </>
  );
};
export default Derogation;
